import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";

export class ProfileFetchRequest {
  public static readonly FetchRequestType: string = "profile_fetch_request";
  login_id: number = 0;
  profile_ids: number[] = [];
  //   FinancialYearRef: number = 0;
  //   Month: number = 0;
  //   IsCalledForTransaction: boolean = false;

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      ProfileFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}
